import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";
import { SelectedSiteHero } from "@/components/selected-site-hero";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const Route = createFileRoute("/dashboard/reports")({
  component: ReportsPage,
  staticData: {
    title: "Reports",
  },
});

const REPORTS = [
  {
    title: "Compliance summary",
    description: "Monthly pass-rate by asset and scope.",
  },
  {
    title: "Overdue equipment",
    description: "Items past next-due date with ageing buckets.",
  },
  {
    title: "Defect register",
    description: "All open and closed defects with rectification times.",
  },
];

function ReportsPage() {
  return (
    <div className="@container/main flex flex-1 flex-col">
      <div className="flex w-full flex-col gap-6 p-4 lg:p-7">
        <SelectedSiteHero
          variant="compact"
          fallback={
            <header className="min-w-0 flex-1 border-b pb-6">
              <h1 className="font-serif text-[22px] font-bold tracking-[-0.01em]">
                Reports
              </h1>
            </header>
          }
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {REPORTS.map((report) => (
            <Card key={report.title} className="gap-4">
              <CardHeader className="gap-2">
                <FileText
                  className="text-muted-foreground mb-2 size-5"
                  strokeWidth={1.5}
                />
                <CardTitle className="text-base font-bold">
                  {report.title}
                </CardTitle>
                <CardDescription>{report.description}</CardDescription>
              </CardHeader>
              <CardContent className="mt-auto">
                <span className="text-muted-foreground text-sm font-medium">
                  Coming soon
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
